<script>
    /*
    	ListActionButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    export let action;
    export let selectedCount;

    $: buttonStyle = getStyle(selectedCount);

    onMount(() => {
    })

    const getStyle = (selectedCount) => {
        if (selectedCount < 2) {
            return 'opacity:.3';
        } else {
            return 'opacity: 1';
        }
    }

</script>

<style>

    .action-button {
        user-select: none;
        min-width: 150px;
        padding: 8px;
        margin: 10px 10px 10px 0px;
        font-size: 14px;
        text-align: center;
        letter-spacing: 1px;
        color: var(--tcare-white);
        background-color: #A075A5;
        border-radius: 18px;
        border: none;
    }

    .action-button:hover {
        color: var(--tcare-primary);
        background-color: var(--tcare-secondary);
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="action-button" style={buttonStyle} on:click={action.action}>
    {action.label}
</div>
